import styles from "../../PPTPlugin/PPTInstallGuidePage.module.css";
import CHROME_URL from "./images/browser_icon_chrome.png";
import FIREFOX_URL from "./images/browser_icon_firefox.png";
import SAFARI_URL from "./images/browser_icon_safari.png";
import OPERA_URL from "./images/browser_icon_opera.png";
import BRAVE_URL from "./images/browser_icon_brave.png";
import EDGE_URL from "./images/browser_icon_edge.png";


export default function SupportedBrowserList() {
    return (
        <div
            className={styles.row}
            style={{
                gap: 12, flexWrap: "wrap", flex: 1,
                minWidth: 260, height: "min-content",
                alignSelf: "center", marginLeft: "auto", justifyContent: "end"
            }}
        >
            <div className={styles.row} style={{gap: 12}}>
                <div className={styles.browserIcon}>
                    <img
                        src={CHROME_URL}
                        alt="Chrome Browser Icon"
                    />
                </div>

                <div className={styles.browserIcon}>
                    <img
                        src={FIREFOX_URL}
                        alt="Firefox Browser Icon"
                    />
                </div>

                <div className={styles.browserIcon}>
                    <img
                        src={SAFARI_URL}
                        alt="Safari Browser Icon"
                    />
                </div>

            </div>
            <div className={styles.row} style={{gap: 12, flexWrap: "wrap"}}>
                <div className={styles.browserIcon}>
                    <img
                        src={OPERA_URL}
                        alt="Opera Browser Icon"
                    />
                </div>

                <div className={styles.browserIcon}>
                    <img
                        src={BRAVE_URL}
                        alt="Brave Browser Icon"
                    />
                </div>

                <div className={styles.browserIcon}>
                    <img
                        src={EDGE_URL}
                        alt="Edge Browser Icon"
                    />
                </div>
            </div>
        </div>
    );
}